export default "/images/picture.png";